// extracted by mini-css-extract-plugin
module.exports = {"office__city":"Office_office__city__2k4YI","office__location":"Office_office__location__XLDPm","office__address":"Office_office__address__2WJnP"};